import { lazy } from 'react';

export const OutCorListLazy = lazy(() => import('./OutCorList'));
